<template>
    <div>
        <ScrollTop />
        <ScrollPanel style="height: 800px">
            <!-- DIALOGO DE LOADING -->
            <Dialog :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }">
                <ProgressBar mode="indeterminate" style="height: .5em" />
                <div
                    class="scalein animation-duration-2000 animation-iteration-infinite flex align-items-center justify-content-center font-bold border-round m-2 px-5 py-3">
                    {{ loadingMensaje }}</div>
            </Dialog>

            <!-- DIALOG DEL PDF -->
            <Dialog :visible.sync="dialogPdf" :style="{ width: '850px' }" :closable="false">
                <comprobante-pdf @cierraDialogPdf="closeDialogPdf"></comprobante-pdf>
            </Dialog>

            <Card>
                <!-- TITULO CARD -->
                <template #title>
                    <div class="p-d-flex p-fluid grid formgrid">
                        <div class="text-left field col-4">
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined"
                                @click="cierraVentana()" />
                        </div>
                        <div class="text-center field col-4">
                            Remisión
                        </div>
                        <div class="text-right field col-4">
                            <template v-if="ventaRemision.idVenta === 0">
                                <Button icon="pi pi-save" @click="postVentaRemision()"
                                    class="p-button-rounded p-button-success p-button-outlined" />
                            </template>
                            <template v-if="ventaRemision.idVenta != 0">
                                <Button icon="pi pi-save" @click="editVentaRemision()"
                                    class="p-button-rounded p-button-warning p-button-outlined" />
                            </template>
                            <Button icon="pi pi-file-pdf"
                                class="ml-3 mr-1 p-button-rounded p-button-danger p-button-outlined"
                                @click="vistaPrevia" />
                        </div>
                    </div>
                    <hr size=7 color="#ED6421">
                </template>
                <template #content>
                    <TabView>
                        <TabPanel header="Datos generales">
                            <General></General>
                        </TabPanel>
                        <TabPanel header="Conceptos">
                            <Conceptos></Conceptos>
                        </TabPanel>
                    </TabView>
                </template>
                <template #footer>
                    <div style="justify-content:right" class="p-d-flex justify-center p-fluid grid formgrid col-12">
                        <div class="field col-12 md:col-3">
                            <span class="p-float-label">
                                <InputNumber v-model="$store.state.ventaRemisionStore.subTotal" mode="decimal"
                                    :minFractionDigits="2" locale="en-US" />
                                <label>SubTotal</label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-3">
                            <span class="p-float-label">
                                <InputNumber class="color" v-model="$store.state.ventaRemisionStore.total"
                                    mode="decimal" :minFractionDigits="2" locale="en-US" />
                                <label>Total</label>
                            </span>
                        </div>
                    </div>
                </template>
            </Card>
            <ScrollTop target="parent" :threshold="100" class="custom-scrolltop" icon="pi pi-arrow-up" />
        </ScrollPanel>
    </div>
</template>
<script>
import axios from 'axios'
import General from './VentaRemisionGeneral';
import Conceptos from './VentaRemisionConcepto'
import ComprobantePdf from "../Pdf/VentaRemisionPdf";

export default {
    components: {
        General,
        Conceptos,
        ComprobantePdf
    },

    data() {
        return {
            loading: false,
            loadingMensaje: '',
            dialogPdf: false,
            datosEmpresa: null,
        }
    },
    computed: {
        ventaRemision() {
            return this.$store.state.ventaRemisionStore;
        },
        token() {
            return this.$store.state.usuario;
        },
    },
    created() {
        this.Inicializa();
    },
    methods: {
        async Inicializa() {
            this.loading = true;
            await this.GetEmpresa();
            await this.GetSerie();
            await this.GetClientes();
            await this.GetMoneda();
            await this.GetProyectos();
            await this.GetConceptos();
            await this.GetObjImpuestos();
            await this.GetTraslados();
            await this.GetRetenciones();
            await this.GetMetododPago();
            await this.GetFormaPago();
            this.loading = false;
        },

        async GetEmpresa() {
            try {
                this.loadingMensaje = 'Consultando datos de la empresa'
                let response = await axios.get('Empresas/GetEmpresa/' + this.token.empresaBase);
                this.datosEmpresa = response.data
                console.log(response.data)
            } catch (error) {
                console.log(error)
            }
        },
        async GetSerie() {
            try {
                this.loadingMensaje = 'Consultando serie'
                let response = await axios.get("Ventas/GetVentasRemisionSeries/" + this.token.empresaBase);
                this.$store.state.listVentaRemisionSerieStore = response.data;
            } catch (error) {
                console.log(error)
            }
        },
        async GetClientes() {
            this.loadingMensaje = 'Consultanod Clientes';
            try {
                let response = await axios.get("Clientes/GetClientes/" + this.token.empresaBase);
                this.$store.state.listClienteStore = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async GetMoneda() {
            this.loadingMensaje = 'Consultando Monedas';
            if (this.$store.state.monedaStore.length != 0) {
                return
            }
            try {
                let result = await axios.get('CatalogosSat/GetMoneda/');
                this.$store.state.monedaStore = result.data;
            } catch (error) {

            }
        },
        async GetProyectos() {
            this.loadingMensaje = 'Consultando Proyectos';
            try {
                let response = await axios.get('Proyectos/GetProyectos/' + this.token.empresaBase)
                let pro = response.data;
                for (var a of pro) {
                    a.asignado = 0;
                }
                this.$store.state.listProyectosStore = pro

            } catch (error) {
                this.loadingItemsProyectos = false;
            }
        },
        async GetConceptos() {
            try {
                this.loadingMensaje = 'Consultando Conceptos';
                let response = await axios.get('Conceptos/GetConceptos/' + this.token.empresaBase)
                this.$store.state.listaConceptosStore = response.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetObjImpuestos() {
            this.loadingMensaje = 'Consultando Objeto de impuestos';
            if (this.$store.state.objImpStore.length != 0) {
                return
            }
            try {
                let response = await axios.get('CatalogosSat/GetObjImp/');
                this.$store.state.objImpStore = response.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetTraslados() {
            this.loadingMensaje = 'Consultando Impuestos Trasladados';
            if (this.$store.state.trasladosStore.length != 0) {
                return
            }
            try {
                let response = await axios.get('Impuestos/GetTraslados/');
                this.$store.state.trasladosStore = response.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetRetenciones() {
            this.loadingMensaje = 'Consultando Impuestos Retenidos';
            if (this.$store.state.retencionesStore.length != 0) {
                return
            }
            try {
                let response = await axios.get('Impuestos/GetRetenciones/');
                this.$store.state.retencionesStore = response.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetMetododPago() {
            this.loadingMensaje = 'Consultando Métodos de Pago';
            if (this.$store.state.metodoPagoStore.length != 0) {
                return
            }
            try {
                let result = await axios.get('CatalogosSat/GetMetodoPago/');
                this.$store.state.metodoPagoStore = result.data;
            } catch (error) {

            }
        },
        async GetFormaPago() {
            this.loadingMensaje = 'Consultando Formas de Pago';
            if (this.$store.state.formaPagoStore.length != 0) {
                return
            }
            try {
                let result = await axios.get('CatalogosSat/GetFormaPago/');
                this.$store.state.formaPagoStore = result.data;
            } catch (error) {

            }
        },
        async postVentaRemision() {
            try {
                this.loading = true;
                this.loadingMensaje = 'Guardando espere...'
                let objRemision = { ...this.ventaRemision }
                objRemision.empresa = this.datosEmpresa
                objRemision.rfc = objRemision.cliente.rfc
                objRemision.nombre = objRemision.cliente.nombre

                objRemision.usuarioCreador = this.token.nombre

                let response = await axios.post('Ventas/PostVentaRemision/' + this.token.empresaBase, objRemision)
                console.log(response.data)

                objRemision.idVenta = response.data.id;
                objRemision.folio = response.data.folio;
                this.$store.state.listVentaRemisionStore.push(objRemision)

                if (objRemision.idRelacion != 0) {
                    let indice = this.$store.state.listVentaPedidoStore.findIndex(x => x.idVenta === objRemision.idRelacion);
                    this.$store.state.listVentaPedidoStore[indice].estatus = 'Remision';
                }

                let array = this.$store.state.listVentaRemisionStore;
                this.$store.state.listVentaRemisionStore = array.sort(((a, b) => b.folio - a.folio))
                this.$store.state.ventaRemisionStore.idVenta = -1;

                this.loading = false;
                this.$toast.add({ severity: 'success', detail: 'Remisión guardada con éxito', life: 3000 });
                this.cierraVentana();
            } catch (error) {
                console.log(error)
                this.$toast.add({ severity: 'error', detail: 'Error al guardar, intente nuevamente', life: 3000 });
                this.loading = false;
            }
        },

        async editVentaRemision() {
            try {
                this.loading = true;
                this.loadingMensaje = 'Guardando espere...'
                this.ventaRemision.empresa = this.datosEmpresa
                this.ventaRemision.rfc = this.ventaRemision.cliente.rfc
                this.ventaRemision.nombre = this.ventaRemision.cliente.nombre
                this.ventaRemision.estatus = 'Modificada'

                this.ventaRemision.usuarioModificador = this.token.nombre

                let response = await axios.post('Ventas/UpdateVentasRemision/' + this.token.empresaBase, this.ventaRemision)
                console.log(response.data)

                //BUSCAMOS EL INDICE
                let indice = this.$store.state.listVentaRemisionStore.findIndex(x => x.idVenta === this.ventaRemision.idVenta);
                Object.assign(this.$store.state.listVentaRemisionStore[indice], this.ventaRemision)

                this.loading = false;
                this.cierraVentana();
                this.$toast.add({ severity: 'success', detail: 'Remisión actualizada con éxito', life: 3000 });
            } catch (error) {
                console.log(error)
                this.$toast.add({ severity: 'error', detail: 'Error al actualizar, intente nuevamente', life: 3000 });
                this.loading = false;
            }
        },

        cierraVentana() {
            this.$emit('closeVentaRemision')
            this.$store.state.ventaRemisionStore.idVenta = -1;

        },

        vistaPrevia() {
            this.dialogPdf = true;
            console.log(this.$store.state.ventaRemisionStore)
        },

        closeDialogPdf() {
            this.dialogPdf = false

            if (this.ventaRemision.folio != '') {
                this.$emit('closeVentaRemision')
            }
        },
    },
}
</script>